import type { InferOutput } from 'valibot';
import { object as vObject, string as vString, number as vNumber } from 'valibot'; // destruct to be sure that we don't ship whole valibot library to frontend

export type AddressSearch = InferOutput<typeof AddressSearchSchema>;
export const AddressSearchSchema = vObject({
  id: vString(),
  fullAddress: vString(),
});

export type AddressRetrieve = InferOutput<typeof AddressRetrieveSchema>;
export const AddressRetrieveSchema = vObject({
  id: vString(),
  fullAddress: vString(),
  postcode: vString(),
  place: vString(),
  coordinates: vObject({
    latitude: vNumber(),
    longitude: vNumber(),
  }),
}, 'core.form.error.mandatory_field');
